import { Typography } from "@mui/material";
import { PickersCalendarHeaderProps } from "@mui/x-date-pickers-pro";
import { FC } from "react";

const CustomCalendarHeader: FC<PickersCalendarHeaderProps> = ({
  currentMonth,
}) => (
  <Typography
    variant="subtitle1"
    color="textSecondary"
    textAlign="center"
    mb="1rem"
  >
    {currentMonth.toLocaleString("default", { month: "long" })}
  </Typography>
);

export default CustomCalendarHeader;
